import { Component, Input, SimpleChanges } from '@angular/core';
import { IDonutChartItem } from '../../../../controls/donut-chart/donut-chart.component';
import { IBallotCommitteeMemberDto } from '../../../shared/models/ballot-base/ballot-committee-member-dto';


@Component({
    selector: 'app-ci-consensus-criteria',
    templateUrl: './ci-consensus-criteria.component.html',
    styleUrl: './ci-consensus-criteria.component.scss',
    standalone: false
})
export class CiConsensusCriteriaComponent {
  @Input() ballotVotes: IBallotCommitteeMemberDto[] = [];
  @Input() data: IDonutChartItem[] = [];
  @Input() isRefresh: boolean = false;
  isShowingHelp: boolean = false;
  hasMetConsensus: boolean = false;


  ngOnInit() {
    this.calculatePercentages();
  }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['data'] && !changes['data'].firstChange && this.isRefresh) {
          this.calculatePercentages();
      }
    }
  openModal() {
    this.isShowingHelp = true;
  }

  closeModal() {
    this.isShowingHelp = false;
  }

  calculatePercentages() {
    const total = this.data.reduce((sum, item) => sum + (item.value ?? 0), 0);
    // Calculate percentage and round
    let percentages = this.data.map(item => ({
      ...item,
      percentage: total ? Math.round((item.value / total) * 100) : 0
    }));

    // Adjust rounding errors to ensure the total is exactly 100%
    let diff = 100 - percentages.reduce((sum, item) => sum + item.percentage, 0);
    if (diff !== 0) {
      let indexToAdjust = percentages.findIndex(item => item.percentage > 0);
      if (indexToAdjust !== -1) {
        percentages[indexToAdjust].percentage += diff;
      }
    }

    this.data = percentages;
    this.checkConsensus();
  }

  checkConsensus(){
    if(this.data && this.data.length > 0){
      const filteredData = this.data.filter(item => item.label !== 'No Response');
      const maxPercentage = Math.max(...filteredData.map(item => item.percentage || 0));
      const roundedPercentage = Math.round(maxPercentage);
      if(roundedPercentage >= 67){
        this.hasMetConsensus = true;
      }
    }
  }
}
